import React, { Component } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import App_data from '../../config/App_data';
import FD from '../../RestAPI/fetchData';
import './Auth.css';
import language from '../../../assets/languages/language';

class ForgotModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      message: '',
      message_background: 'bg-danger',
      displaytext: 'hide_block',
      status: '',
    };
    this.updateEmail = this.updateEmail.bind(this);
    this.forgetPassword = this.forgetPassword.bind(this);
    this.handleResend = this.handleResend.bind(this);
  }
  updateEmail(e) {
    this.setState({
      email: e.target.value,
      message: '',
    });
  }
  forgetPassword(event) {
    event.preventDefault();
    if (this.state.email === '') {
      this.setState({
        message: `${language.LC().Email_is_Required}`,
        displaytext: 'show_block',
      });
      return;
    }

    var emailValid = this.state.email.match(
      /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i
    );
    if (emailValid) {
      // alert(this.state.email);
      var data = { idname: this.state.email };
      FD.callAPI(App_data.backend_api + '/user/forgetPassword', data).then(
        (resp) => {
          if (resp.success) {
            this.setState({ status: 'success', message: '', email: '' });
          } else {
            this.setState({ displaytext: 'show_block' });
            this.setState({ message: `${language.LC().Email_Id_Not_Exist}` });
            this.setState({ message_background: 'bg-danger' });
          }
        }
      );
    } else {
      this.setState({ displaytext: 'show_block' });
      this.setState({ message: `${language.LC().Email_Id_Invalid}` });
      this.setState({ message_background: 'bg-danger' });
    }
  }
  componentWillReceiveProps() {
    this.setState({
      message: '',
    });
  }

  toggleAlert = () => {
    this.props.onToggle(this.props.forgotOpen);
  };
  handleResend() {
    this.setState({ status: '' });
  }

  render() {
    return (
      <Modal
        isOpen={this.props.forgotOpen}
        toggle={this.toggleAlert}
        className='forgot-modal'
      >
        <ModalBody>
          {this.state.status !== 'success' ? (
            <div className={'forgot-block'}>
              <div className='text-center foget-password-img'>
                <img
                  src={App_data.frontend_url + '/img/forget-password.png'}
                  alt=''
                />
              </div>
              <div className='text-center heading foget-password-heading'>
                {language.LC().FORGOT_PASSWORD}
              </div>
              <p className='forgot-text foget-password-text'>
                {language.LC().ENTER_YOUR_EMAIL_ADDRESS}
              </p>
              <form onSubmit={this.forgetPassword}>
                <p className={this.state.displaytext + ' text-danger'}>
                  {this.state.message}
                </p>
                <div className='form-group forget-password-value'>
                  <input
                    type='text'
                    className='form-control '
                    placeholder='Email'
                    value={this.state.email}
                    onChange={this.updateEmail}
                  />
                  <p className={this.state.displaytext + ' text-danger'}>
                    {this.state.emailErrorMessage}
                  </p>
                </div>
                <button className='btn forgot-button btn-block pointer_class'>
                  {language.LC().SUBMIT}
                </button>
              </form>
            </div>
          ) : (
            <div className={'success-block'}>
              <div className='text-center foget-password-img'>
                <img src={App_data.frontend_url + '/img/check.png'} alt='' />
              </div>
              <div className='text-center heading foget-password-heading'>
                {language.LC().CHECK_YOUR_EMAIL}
              </div>
              <p className='success-text foget-password-text forget-password-value'>
                {language.LC().RESTE_PASSWORD_LINK}{' '}
              </p>
              <button
                className='btn resend-button btn-block pointer_class'
                onClick={this.handleResend}
              >
                {language.LC().RESEND_EMAIL}{' '}
              </button>
            </div>
          )}
        </ModalBody>
      </Modal>
    );
  }
}

export default ForgotModal;



// WEBPACK FOOTER //
// ./src/views/Pages/Auth/ForgotModal.js